/* Auto generated by gulp-typescript-template */

export const Tag = `<div class="Tag filter-button [[ checked ? '-active' : '' ]]" on-click="[[ checked = !checked ]]"> [[ this.trans(label) ]]</div>`;
